import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/trackers";
const listQuery = { orderBy: ["id desc"] };

const index = ({ preparedFilter, trackerId, ...params }: OdataFilters & { trackerId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter, ...listQuery });
    return request(`${resource}/getHistoryItems/${trackerId}${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => alertRequest(`${resource}/applyHistoryItem`, body(params));

const getItem = (params: { id: number }) => request(`${resource}/getHistoryItem/${params.id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/deleteHistoryItem`, body(params));

export { index, apply, getItem, delItem };
